import {
  Button,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography
} from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import axios from "axios";
import { useField } from "formik";
import _ from "lodash";
import React, { useEffect } from "react";

const FileUploaderField = ({ name, label, buttonLabel, accept }) => {
  const [field, { initialValue }, { setValue }] = useField(name);

  useEffect(() => {
    if (initialValue?.url) {
      const getFiles = async () => {
        const { data } = await axios({ url: initialValue.url, responseType: "blob" });
        const initialFile = new File(
          [data],
          initialValue.filename || _.last(initialValue.url.split("/"))
        );
        setValue(initialFile);
      };
      getFiles();
    } else {
      setValue(null);
    }
  }, [initialValue, setValue]);

  const onFileUpload = e => {
    setValue(e.target.files[0]);
  };

  const onFileRemove = () => {
    setValue(null);
  };

  return (
    <>
      <Typography variant="body1">{label}</Typography>
      {field.value && (
        <List>
          <ListItem key={field.value.name}>
            <ListItemText primary={field.value.name} />
            <ListItemSecondaryAction>
              <IconButton onClick={onFileRemove}>
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      )}
      <Button variant="contained" color="primary" component="label" size="small">
        {buttonLabel}
        <input type="file" accept={accept} hidden onChange={onFileUpload} />
      </Button>
    </>
  );
};

export default FileUploaderField;
